import React, { useEffect, useState } from 'react';
import SupervisorsList from '../../Components/SupervisorsItems/SupervisorsList/SupervisorsList';
import apiClient from '../../../../../Config/apiClient';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';
import { hasPermission } from '../../Services/permission';

const apiPath = process.env.REACT_APP_CC_SUPERVISORS_BASE_PATH;

const SUPERVISOR_SECTION = "supervisors";
const SUPERVIOSR_EDIT_KEY = ["supervisors_edit"];

const Supervisors = () => {
    const [supervisors, setSupervisors] = useState([]);
    const [loading, setLoading] = useState(true);

    const canEditSupervisor = hasPermission({ section: SUPERVISOR_SECTION, keys: SUPERVIOSR_EDIT_KEY });

    const fetchSupervisors = async (filtered = null) => {
        if (filtered) {
            setSupervisors(filtered);
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const res = await apiClient.post(`${apiPath}/list`);
            if (res.data.status === 'SUCCESS') {
                setSupervisors(res.data.data);
            } else {
                showErrorToast(res.data.message || 'Failed to fetch supervisors');
            }
        } catch (err) {
            showErrorToast('Error fetching supervisors');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSupervisors();
    }, []);

    return (
        <SupervisorsList supervisors={supervisors} loading={loading} refreshSupervisorList={fetchSupervisors} canEditSupervisor={canEditSupervisor}/>
    );
};

export default Supervisors;
